import React from 'react';
import { ProfileDataItem } from 'pages/Profile/components/ProfileDataItem/ProfileDataItem';
import Label from 'components/form/Label/Label';

export const Name = ({ firstName, lastName, ...props }) => {
  const legalName = `${firstName} ${lastName}`;

  const { Title, DisplayView } = ProfileDataItem;
  let profileDataItemClass = props.classNameOverwrites?.profileDataItem;
  return (
    <ProfileDataItem
      datatestid="profileName"
      classNameOverwrites={profileDataItemClass?.profileDataItem}
    >
      <Title datatestid="nameLabel" labelType={profileDataItemClass?.title}>
        Name
      </Title>
      <DisplayView
        datatestid="nameValDisplay"
        className={props.classNameOverwrites?.displayView}
      >
        <Label datatestid="legalNameReadOnly" type="Body-1">
          {legalName}
        </Label>
      </DisplayView>
    </ProfileDataItem>
  );
};
